module.exports = __webpack_public_path__ + "static/img/operateWeek.3818d8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/operateWeek.png
// module id = ThUQ
// module chunks = 1